import React from 'react';
import Button from '@material-ui/core/Button';
import { NavLink } from 'react-router-dom';

const Navbar = () => {
    return (
        <div className="navbar-menu">

            <NavLink exact to="/Education" activeClassName="active">
                <Button color="primary">
                    <div className="item-menu Educ">
                        <i className="icon-mortarboard"></i>
                        <i className="icon-mortarboard-3-fill"></i>
                        <span>آموزش</span>
                    </div>
                </Button>
            </NavLink>
            <NavLink exact to="/Award" activeClassName="active">
                <Button color="primary">
                    <div className="item-menu award">
                        <i className="icon-present-box"></i>
                        <i className="icon-present-box-1-fill"></i>
                        <span>جایزه</span>
                    </div>
                </Button>
            </NavLink>
            <NavLink exact to="/" activeClassName="active">
                <Button color="primary">
                    <div className="item-menu indx">
                        <i className="icon-home"></i>
                        <i className="icon-home-1-fill"></i>
                        <span>صفحه اصلی</span>
                    </div>
                </Button>
            </NavLink>
            <NavLink exact to="/News" activeClassName="active">
                <Button color="primary">
                    <div className="item-menu nws">
                        <i className="icon-newsfeed"></i>
                        <i className="icon-newsfeed-1-fill"></i>
                        <span>اخبار</span>
                    </div>
                </Button>
            </NavLink>
            <NavLink exact to="/Profile" activeClassName="active">
                <Button color="primary">
                    <div className="item-menu prfil">
                        <i className="icon-user"></i>
                        <i className="icon-user-1-fill"></i>
                        <span>پروفایل</span>
                    </div>
                </Button>
            </NavLink>


        </div>
    );
}

export default Navbar;